import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import { findCursus } from "../services/functions"
import cursus from "../services/cursus.json"
import { Grid } from "@mui/material"
import { Dropdown } from "components/fields"

const Cursus = () => {

  const { control, setValue, watch } =useFormContext()

  // const campus = watch('lead.Campus__c')
  // const academicLevel = watch('lead.AcademicLevel__c')
  const watchCursus = watch('cursus')
  const [optionsCursus, setOptionsCursus] = useState([])

  useEffect(() => {
    setValue('cursus', '')
    setValue('cycle', '')
    const formationsByCampus = findCursus(cursus)
    setOptionsCursus(formationsByCampus)
  }, [])

  useEffect(() => {
    for (const options of cursus) {
      setValue(options.field, false)
    }
    if (watchCursus.length > 0) {
      const { field, fullName } = optionsCursus.find(el => el.label === watchCursus)
      console.log('field', field)
      console.log('fullName', fullName)
      setValue(field, true)
      setValue('cycle', fullName)
    }
  }, [watchCursus])

  return (
    <>
      {optionsCursus.length > 0 && (
        <Grid item xs={12}>
          <Dropdown control={control} label={`Cursus d'intérêt`} name="cursus" options={optionsCursus} required />
        </Grid>
      )}
    </>
  )
}

export default Cursus
